import type { ThemeWithLookSystem } from "@/types/look-system";

/**
 * The one gate for the look system: without it every renderer path must stay today's path, byte for byte.
 * The CMS's `isRewebLookSystem` uses the same rule, so keep the two identical.
 */
export function isLookSystem(theme: unknown): theme is ThemeWithLookSystem {
  return (
    typeof (theme as { colorSystem?: { version?: unknown } } | null | undefined)
      ?.colorSystem?.version === "number"
  );
}

/** `theme.colorSystem.derived.version`; 1 where it is absent or not a number, as every `derived` before version 2. */
export function derivedVersion(theme: unknown): number {
  const version = (
    theme as { colorSystem?: { derived?: { version?: unknown } } } | null
  )?.colorSystem?.derived?.version;
  return typeof version === "number" && Number.isFinite(version) ? version : 1;
}

/**
 * Derived v2: the CMS stores every colour the website paints, guaranteed readable and with visible states, so the
 * renderer only maps them. Every derived-v2 path sits behind this; a website below it keeps today's output byte for byte.
 */
export function isDerivedV2(theme: unknown): boolean {
  return isLookSystem(theme) && derivedVersion(theme) >= 2;
}
